import { RootState } from "@/redux/store";

export const profileSelector = (state: RootState) => state.profile.profile;
